import { useEffect } from 'react';
import { dispatch } from 'nike-re-framejs';
import { removeMarketStats } from '../reframe/h&s';

const useRemoveMarketStats = matchId => {
    useEffect(() => {
        return () => {
            dispatch(removeMarketStats(matchId));
        };
    }, [matchId]);
};

export default useRemoveMarketStats;
